/**
 * @fileoverview POST handler for the "/engagement/prediction/clone" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementPredictionCloneCacheKeys } from "./constants";
import type { PostEngagementPredictionCloneProps, EngagementPredictionCloneResult } from "./types";

export const postEngagementPredictionClone = reactQueryMutationAdapter(
  engagementPredictionCloneCacheKeys,
  (props: PostEngagementPredictionCloneProps): Promise<EngagementPredictionCloneResult> => {
    return fetch(
      "/engagement/prediction/clone",
      "POST",
      { app_group_id: props.appGroupId, prediction_id: props.predictionId, name: props.name },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
